export default {
  header: {
    breadcrumb: 'ADMin',
    title: 'Sites',
    filters: {
      accountSelect: {
        label: 'Account',
        placeholder: 'Select...',
      },
      searchInput: {
        placeholder: 'Search...',
      },
    },
  },
  sitesTable: {
    headers: {
      url: 'URL',
      accountRef: 'Account ref',
      activeSchemes: 'Active schemes',
      testSchemes: 'Test schemes',
      cases: 'Cases',
      users: 'Users',
      created: 'Created',
      status: 'Status',
    },
    body: {
      status: {
        active: 'Active',
        disabled: 'Disabled',
      },
    },
  },
  addNewSiteModal: {
    title: 'New site',
    nameInput: {
      label: 'Site name',
      placeholder: 'Site name...',
    },
    urlInput: {
      label: 'Account URL',
      placeholder: 'Account URL...',
    },
    accountSelect: {
      label: 'Account',
      placeholder: 'Select...',
    },
    userSelect: {
      label: 'Default user',
      placeholder: 'Select...',
    },
  },
  editSiteModal: {
    title: 'Site: {{ siteName }}',
    tabs: {
      overview: {
        title: 'Overview',
        nameInput: {
          label: 'Site name',
          placeholder: 'Site name...',
        },
        urlInput: {
          label: 'Account URL',
          placeholder: 'Account URL...',
        },
        accountSelect: {
          label: 'Account',
          placeholder: 'Select...',
        },
      },
      stats: {
        title: 'Stats',
      },
      features: {
        title: 'Features',
      },
      settings: {
        title: 'Settings',
        table: {
          headers: {
            id: 'ID',
            key: 'Key',
            value: 'Value',
            accessGroup: 'Access group',
          },
        },
      },
    },
  },
};
